import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
const baseUrl = `${BASE_URL}/crm`;

const getAchievement = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getAchievementById = async (achievementId: string) => {
  return await httpClient
    .get(`${baseUrl}/achievement/${achievementId}`)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const createStep1 = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/create-achievement`, params)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDataStep1 = async (achievementId: string) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-achievement-detail/${achievementId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateFile = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-doc`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createMainStep2 = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-achievement-main-reward`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createSpecialStep2 = async (data: FormData) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-achievement-special-reward`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDataStep2 = async (achievementRewardId: string) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-achievement-reward-detail/${achievementRewardId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const updateStatusSpecialReward = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-is-special-reward`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const deleteAchievementReward = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/delete-achievement-reward`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const createStep3 = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-achievement-product-shop`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getDataStep3 = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-achievement-product-shop-detail`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const deleteProductShop = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/delete-achievement-product-shop`, data)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const achievementShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/achievement-shop`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const achievementProduct = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/achievement-product`, { params })
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const approveAchieve = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/approve-achievement`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const deleteAchievement = async (achievementId: string) => {
  return await httpClient
    .delete(`${baseUrl}/achievement/delete-achievement/${achievementId}`)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getFollowAchieve = async (achievementId: string) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-follow-achievement/${achievementId}`)
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getFollowAchieveShop = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-follow-achievement-detail`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getAchieveShopDetail = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-shop-detail`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const getAchieveShopDetailOrderProd = async (params: object) => {
  return await httpClient
    .get(`${baseUrl}/achievement/get-shop-detail-order-product`, { params })
    .then((res: AxiosResponse) => {
      return res.data.responseData;
    })
    .catch((err) => console.log(err));
};
const updateStatusAchievement = async (params: object) => {
  return await httpClient
    .post(`${baseUrl}/achievement/update-status-achievement`, params)
    .then((res: AxiosResponse) => {
      return res.data;
    })
    .catch((err) => console.log(err));
};
const getHistoryAchievement = async (id: string) => {
  return await httpClient
    .get(`${baseUrl}/achievement/history-achievement/${id}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export {
  getAchievement,
  getAchievementById,
  createStep1,
  updateFile,
  getDataStep1,
  createMainStep2,
  createSpecialStep2,
  getDataStep2,
  deleteAchievementReward,
  createStep3,
  getDataStep3,
  deleteProductShop,
  achievementShop,
  achievementProduct,
  approveAchieve,
  deleteAchievement,
  getFollowAchieve,
  getFollowAchieveShop,
  getAchieveShopDetail,
  getAchieveShopDetailOrderProd,
  updateStatusAchievement,
  getHistoryAchievement,
  updateStatusSpecialReward,
};
